import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'bnDigit' })
export class BnDigitPipe implements PipeTransform {
  constructor() {}

  transform(value: string): string {
    return value === undefined || value === null || value === '' || +value === -1
      ? '--'
      : `${value}`.length === 1
      ? `0${value}`
      : value;
  }
}
